import LogoNoBGP from './LogoNoBGP'
import Stack, { StackProps } from '@mui/material/Stack'

export default function Logo(props: StackProps) {
  return (
    <Stack
      {...props}
      sx={[{
        paddingLeft: 3,
        paddingRight: 3
      }, ...(Array.isArray(props.sx) ? props.sx : [props.sx])]}>
      <LogoNoBGP style={{ width: 100, height: 66 }} />
    </Stack>
  )
}
